<footer class="bg-body-tertiary text-lg-right">
    <!-- Copyright -->
    <div class="text-lg-right p-1" style="background-color: rgba(0, 0, 0, 0.05);">
        Funded by Wellcome
        <img src="assets/wellcome-logo-black.png" style="width: 4%; margin-left: 10px; margin-right: 20px">
    </div>
    <!-- Copyright -->
</footer>
